import React from 'react'
import { Button } from '@material-ui/core'
import Link from '../Link/Link'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import CMSText from '../Global/CMSText'

type TProps = {
  isInStore: boolean
  isBlank?: boolean
  cmsText: any
  cmsDefaultText: any
}

const InStoreReturnLink = ({
  isInStore,
  isBlank,
  cmsText,
  cmsDefaultText,
}: TProps) => {
  const { trackEvent } = useMatomo()

  if (isInStore) {
    return (
      <Link href={'./rdv/return'}>
        <a target={isBlank ? '_blank' : '_self'}>
          <Button
            size={'small'}
            component={'span'}
            variant={'outlined'}
            color={'secondary'}
            onClick={() =>
              trackEvent({
                category: 'In Store',
                action: `User Go to In Store Return appointment page`,
              })
            }
          >
            <CMSText asText data={cmsText} defaultText={cmsDefaultText} />
          </Button>
        </a>
      </Link>
    )
  }
  return null
}

export default InStoreReturnLink
